export default __webpack_public_path__ + "static/media/170.7915dc96.jpg";